import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { createAccount } from '../../containers/createAccount/createAccountSlice';
import { getBrowserSignature } from '../../utils/getBrowserSignature';
import validEmailCheck from '../../utils/emailValidation';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import LoadingButton from '@mui/lab/LoadingButton';

const Credentials = ({
	handleNext,
	uuid,
	sku,
	source,
	ipAddress,
	isJavaScriptEnabled,
	timezone
}) => {
	const dispatch = useDispatch();
	const signatureObj = getBrowserSignature();
	const [emailAddress, setEmailAddress] = React.useState('');
	const [formErrors, setFormErrors] = React.useState({
		emailAddress: false
	});
	const { hasCompleted, isLoading, error } = useSelector(
		(state) => state.createAccountSlice.createAccount
	);

	React.useEffect(() => {
		if (hasCompleted && !isLoading && !error) {
			handleNext();
		}
	}, [hasCompleted, isLoading, error]);

	const handleInputChange = (event) => {
		const { value } = event.target;
		setEmailAddress(value);
	};
	const isInvalid = () => {
		if (emailAddress.trim() === '' || !validEmailCheck(emailAddress)) {
			return true;
		}
		return false;
	};
	const handleValidation = () => {
		if (isInvalid()) {
			setFormErrors({
				emailAddress: true
			});
		} else {
			setFormErrors({
				emailAddress: false
			});
		}
	};

	const handleSubmitCredentials = async () => {
		if (!isInvalid()) {
			const payload = {
				uuid,
				email: emailAddress,
				sku,
				source,
				telemetry: {
					signature: signatureObj.signatureKey,
					color_depth: signatureObj.colorDepth,
					screen_height: signatureObj.height,
					screen_width: signatureObj.width,
					user_agent: signatureObj.userAgent,
					ip_address: ipAddress,
					is_javascript_enabled: isJavaScriptEnabled,
					is_java_enabled: signatureObj.isJavaEnabled,
					timezone
				}
			};

			await dispatch(createAccount(payload));
		} else {
			setFormErrors({
				emailAddress: true
			});
		}
	};
	return (
		<Stack spacing={2}>
			<Typography variant='h5' fontWeight='bold' component='h3'>
				Account Set Up
			</Typography>
			<Typography variant='p'>
				Enter your email address to set up an account
			</Typography>
			{error && (
				<Typography variant='p' fontSize='small' color='error'>
					There was an error processing your email address
				</Typography>
			)}
			<TextField
				onChange={handleInputChange}
				name='emailAddress'
				id='emailAddress'
				label='Email'
				value={emailAddress}
				size='small'
				fullWidth
				required
				onBlur={handleValidation}
				error={formErrors.emailAddress}
				helperText={
					formErrors.emailAddress && 'Please enter a valid email address'
				}
			/>

			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					my: 2
				}}
			>
				<LoadingButton
					variant='outlined'
					color='primary'
					onClick={handleSubmitCredentials}
					loading={isLoading}
				>
					Next
				</LoadingButton>
			</Box>
		</Stack>
	);
};

Credentials.propTypes = {
	handleNext: PropTypes.func,
	uuid: PropTypes.string,
	sku: PropTypes.string,
	source: PropTypes.string,
	ipAddress: PropTypes.string,
	isJavaScriptEnabled: PropTypes.bool,
	timezone: PropTypes.string
};

export default Credentials;
